import { render, staticRenderFns } from "./sy.vue?vue&type=template&id=73de1406&scoped=true"
import script from "./sy.vue?vue&type=script&lang=js"
export * from "./sy.vue?vue&type=script&lang=js"
import style0 from "./sy.vue?vue&type=style&index=0&id=73de1406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73de1406",
  null
  
)

export default component.exports